import { Component, Prop, State, h, Host, Element, Event, EventEmitter } from '@stencil/core';

@Component({
  tag: 'dda-select',
  styleUrls: ['../../global/input.css', '../../global/global.css'],
  shadow: false,
})
export class Ddaselect {
  @Element() el: HTMLElement;

  @Prop() label: string;
  @Prop() options: string;
  @Prop() selected: string; // can be id or text
  @Prop() disabled: boolean = false;
  @Prop() error?: string;
  @Prop() error_message: string;
  @Prop() helper_text: string;
  @Prop() validation_id: string = 'text';
  @Prop() size?: string;
  @Prop() custom_class?: string = '';
  @Prop() component_mode?: string;
  @Prop() aria_label?: string;
  @Prop() button_id: string;
  @Prop() toggle_button_name: string;
  @Prop() option_select_button_name: string;
  @Prop() placeholder: string = '';

  @State() is_open: boolean = false;
  @State() selectedId: number;
  @State() selectedText: string;

  @Event() selectChanged: EventEmitter<{ id: number; text: string }>;

  private get parsedOptions(): { id: number; text: string }[] {
    try {
      return JSON.parse(this.options);
    } catch {
      return [];
    }
  }

  componentWillLoad() {
    const selectedOption = this.parsedOptions.find(
      (opt) => opt.id.toString() === this.selected || opt.text === this.selected
    );
    if (selectedOption) {
      this.selectedId = selectedOption.id;
      this.selectedText = selectedOption.text;
    }
  }

  toggleSelect() {
    if (!this.disabled) {
      this.is_open = !this.is_open;
    }
  }

  selectOption(option: { id: number; text: string }) {
    if (!this.disabled) {
      this.selectedId = option.id;
      this.selectedText = option.text;
      this.is_open = false;
      this.selectChanged.emit(option);
    }
  }

  handleClickOutside = (event: MouseEvent) => {
    if (this.is_open && !this.el.contains(event.target as Node)) {
      this.is_open = false;
    }
  };

  connectedCallback() {
    document.addEventListener('click', this.handleClickOutside);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.handleClickOutside);
  }

  render() {
    return (
      <Host>
        <div
          class={`dda-input-container ${this.custom_class} ${this.component_mode} ${
            this.disabled ? 'dda-input-disabled' : ''
          } dda-input-size-${this.size} dda-validation-${this.error}`}
        >
          {this.label && (
            <label htmlFor={this.button_id} class="dda-input-label">
              {this.label}
            </label>
          )}
          <div class="dda-dropdown-container">
            <button
              name={this.toggle_button_name}
              aria-label={this.aria_label}
              id={this.button_id}
              type="button"
              class="dda-input-field dda-select-header"
              onClick={() => this.toggleSelect()}
            >
              <span class="dda-select-button-label">{this.selectedText || this.placeholder}</span>
              <i class="material-icons">{this.is_open ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</i>
            </button>
            {this.is_open && (
              <div class="dda-input-dropdown-list dda-select-list">
                {this.parsedOptions.length > 0 ? (
                  this.parsedOptions.map((option) => (
                    <button
                      name={this.option_select_button_name}
                      type="button"
                      class={`dda-input-dropdown-item ${this.selectedId === option.id ? 'selected' : ''}`}
                      onClick={() => this.selectOption(option)}
                    >
                      {option.text}
                    </button>
                  ))
                ) : (
                  <div class="dda-input-dropdown-item">No options available</div>
                )}
              </div>
            )}
          </div>
          {this.helper_text && (
            <span class="dda-helper-text" id={this.validation_id}>
              {this.helper_text}
            </span>
          )}
          {this.error_message && (
            <span class="dda-error-message" id={this.validation_id}>
              {this.error_message}
            </span>
          )}
        </div>
      </Host>
    );
  }
}
